export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/approval',
    name: '/approval',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/approval.vue'),
    /* no children */
  },
  {
    path: '/clinics',
    name: '/clinics',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/clinics.vue'),
    /* no children */
  },
  {
    path: '/default',
    name: '/default',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/default.vue'),
    /* no children */
  },
  {
    path: '/drug',
    name: '/drug',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/drug.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/patient',
    name: '/patient',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/patient.vue'),
    /* no children */
  },
  {
    path: '/pbsauthtest',
    name: '/pbsauthtest',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/pbsauthtest.vue'),
    /* no children */
  },
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/vjsf',
    name: '/vjsf',
    component: () => import('/home/ianteohsc/code/scriptworx/sw-approval-gui/src/pages/vjsf.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

